import { engineComponent, NumberUtils } from "neo-common";
import { Communication } from "neo-games";
import { BaseController } from "./BaseController";
import { Paylines } from "../Paylines";
import { PaylinesSelector } from "../PaylinesSelector";
import { Symbols } from "../Symbols";
import { WinAnimator } from "../WinAnimator";
import { Machine } from "../Machine";
import { SwitchElement } from "../../Components/Elements/Graphics/SwitchElement";
import { ContainerElement } from "../../Components/Elements/Graphics/ContainerElement";
import { ComponentTypes } from "../../Components/ComponentTypes";
import { WinAnimator2 } from "../../CustomComponents/WinAnimator2";
import { GameManager } from "../../Managers/GameManager";
import { FrameTimerEventEmitter, CreateFrameTimer, FrameTimerEvents } from "../../Utils/FrameTimer";
import { PlayList } from "../../Components/Sounds/PlayList";
import { DataManager } from "../../Managers/DataManager";
import { Tweens } from "../../Components/Effects/Tweens";
import { ImageElement } from "../../Components/Elements/Graphics/ImageElement";
import Container = PIXI.Container;
import { BetManager } from "../../Managers/BetManager";
import { Mystery } from "../../CustomComponents/Mystery";

type IWin = Communication.Game.IWin;

@engineComponent(ComponentTypes.DisplayObject)
export class BaseView extends ContainerElement {
    private _controller: BaseController;
    private _wasFinished: boolean = false;
    private _outroDelay: FrameTimerEventEmitter;

    private _paylines: Paylines;
    private _paylinesSelector: PaylinesSelector;

    private _symbols: Symbols;
    private _machine: Machine;
    private _noWinContainer: ContainerElement;
    private _winContainer: ContainerElement;
    private _winAnimator: WinAnimator2;

    private _reelsBack: ContainerElement;
    private _reels: ContainerElement;
    private _background: SwitchElement;
    private _logo: ImageElement;

    private _mysteryDelay: FrameTimerEventEmitter;
    private _teasingPostfix: string;
    private _teasingStarted: boolean;

    private _mystery: Mystery;
    private mysteryOutroAllowed: boolean;

    constructor() {
        super();

        this._outroDelay = CreateFrameTimer("outroDelay");
        this._outroDelay.on(FrameTimerEvents.Complete, this.outroFinished.bind(this));

        this._mysteryDelay = CreateFrameTimer("mysteryDelay");
        this._mysteryDelay.on(FrameTimerEvents.Complete, this.mysteryStoppedDelayed.bind(this));

        this._teasingPostfix = "";
        this._teasingStarted = false;

        this.mysteryOutroAllowed = true;
    }

    create(node: Element): void {
        super.create(node);

        if (this.childs != null) {
            for (var key in this.childs) {
                if (this.childs[key] instanceof Paylines) {
                    this._paylines = this.childs[key];
                }

                if (this.childs[key] instanceof PaylinesSelector) {
                    this._paylinesSelector = this.childs[key];
                }

                if (this.childs[key] instanceof Symbols) {
                    this._symbols = this.childs[key];
                    this.removeChild(this._symbols);
                }

                if (this.childs[key] instanceof Machine) {
                    this._machine = this.childs[key];
                }

                if (this.childs[key] instanceof WinAnimator) {
                    this._winAnimator = this.childs[key];
                }

                if (key === "NoWinContainer" && this.childs[key] instanceof ContainerElement) {
                    this._noWinContainer = this.childs[key];
                }

                if (key === "WinContainer" && this.childs[key] instanceof ContainerElement) {
                    this._winContainer = this.childs[key];
                }

                if (key === "ReelsBack" && this.childs[key] instanceof ContainerElement) {
                    this._reelsBack = this.childs[key];
                }

                if (key === "Reels" && this.childs[key] instanceof ContainerElement) {
                    this._reels = this.childs[key];
                }

                if (key === "Background" && this.childs[key] instanceof SwitchElement) {
                    this._background = this.childs[key];
                }

                if (key === "Logo" && this.childs[key] instanceof ImageElement) {
                    this._logo = this.childs[key];
                }

                // if (key === 'Mystery' && this.childs[key] instanceof SwitchElement) {
                //     let switchElement: SwitchElement = this.childs[key];
                //     this._mystery = <any> switchElement.getChildElementByName('MysteryCounter');
                // }
            }

            if (this._symbols == null) {
                if (DEBUG) {
                    this.log("ERROR no symbols");
                }
            }

            if (this._machine == null) {
                if (DEBUG) {
                    this.log("ERROR no machine");
                }
            }

            if (this._paylines == null) {
                if (DEBUG) {
                    this.log("WARNING no paylines");
                }
            }

            if (this._winAnimator == null) {
                if (DEBUG) {
                    this.log("WARNING no winAnimator");
                }
            }
        }
    }

    initReceived(controller: BaseController): void {
        if (DEBUG) {
            this.log("initReceived");
        }

        this._controller = controller;

        if (this._symbols != null) {
            if (this._machine != null) {
                if (GameManager.baseResponse != null) {
                    if (GameManager.baseResponse.initData != null && GameManager.baseResponse.initData.reels != null) {
                        this._machine.on(Machine.ReelStopped, this.onReelStopped.bind(this));
                        this._machine.on(Machine.MachineStopped, this.machineStopped.bind(this));
                        this._machine.on(Machine.Teasing, this.teasing.bind(this));
                        this._machine.initialize(this._symbols, GameManager.baseResponse.initData.reels);
                    }

                    if (
                        GameManager.baseResponse.screen != null &&
                        GameManager.baseResponse.screen.reels != null &&
                        GameManager.baseResponse.screen.reels.length !== 0
                    ) {
                        if (this._winAnimator != null) {
                            this._winAnimator.on(
                                WinAnimator.FinishWinCalculation,
                                this.finishWinCalculation.bind(this),
                            );
                            this._winAnimator.on(WinAnimator.FinishWinAnimator, this.finishWinAnimator.bind(this));
                            this._winAnimator.initialize(
                                this._symbols,
                                this._paylines,
                                this._noWinContainer,
                                this._winContainer,
                            );
                            this._winAnimator.showSymbols(GameManager.baseResponse.screen.reels);
                        }
                        // if (this._mystery!=null) {
                        // this._mystery.on(Mystery.FinishMysteryWin, this.finishMysteryWin.bind(this));
                        // this._mystery.on(Mystery.FinishMysteryWin, () => {
                        //     let x=1;
                        // });
                        // }
                        this._machine.setStoppedSymbolsArray(GameManager.baseResponse.screen.reels);
                    } else {
                        if (DEBUG) {
                            this.log("ERROR no reels in response");
                        }
                    }
                } else {
                    if (DEBUG) {
                        this.log("ERROR no base reponse");
                    }
                }
            } else {
                if (DEBUG) {
                    this.log("ERROR no machine");
                }
            }
        } else {
            if (DEBUG) {
                this.log("ERROR no symbols");
            }
        }

        this.toggleElements(false);
    }

    disableLogo(): void {
        if (this._logo != null) {
            this.removeChild(this._logo);
            this._logo = null;
        }
    }

    toggleElements(visible: boolean, long: boolean = false): void {
        if (long) {
            if (visible) {
                if (this._reelsBack != null) {
                    this._reelsBack.visible = true;
                    Tweens.removeTweens(this._reelsBack, "all");
                    Tweens.alphaTween(this._reelsBack, {
                        alphas: [0, 1],
                        tweenDuration: 15,
                    });
                }
                if (this._reels != null) {
                    this._reels.visible = true;
                    Tweens.removeTweens(this._reels, "all");
                    Tweens.alphaTween(this._reels, {
                        alphas: [0, 1],
                        tweenDuration: 15,
                    });
                }
                if (this._noWinContainer != null) {
                    this._noWinContainer.visible = true;
                    Tweens.removeTweens(this._noWinContainer, "all");
                    Tweens.alphaTween(this._noWinContainer, {
                        alphas: [0, 1],
                        tweenDuration: 15,
                    });
                }
                if (this._winContainer != null) {
                    this._winContainer.visible = true;
                    Tweens.removeTweens(this._winContainer, "all");
                    Tweens.alphaTween(this._winContainer, {
                        alphas: [0, 1],
                        tweenDuration: 15,
                    });
                }
                if (this._paylines != null) {
                    this._paylines.visible = true;
                    Tweens.removeTweens(this._paylines, "all");
                    Tweens.alphaTween(this._paylines, {
                        alphas: [0, 1],
                        tweenDuration: 15,
                    });
                }
                if (this._winAnimator != null) {
                    this._winAnimator.visible = true;
                    Tweens.removeTweens(this._winAnimator, "all");
                    Tweens.alphaTween(this._winAnimator, {
                        alphas: [0, 1],
                        tweenDuration: 15,
                    });
                }
                // if(this._logo != null) {
                //     this._logo.visible = true;
                //     Tweens.removeTweens(this._logo, 'all');
                //     Tweens.alphaTween(this._logo, {
                //         alphas: [0, 1],
                //         tweenDuration: 15
                //     });
                // }
            } else {
                if (this._reelsBack != null) {
                    Tweens.removeTweens(this._reelsBack, "all");
                    Tweens.alphaTween(this._reelsBack, {
                        alphas: [1, 0],
                        tweenDuration: 15,
                    });
                }
                if (this._reels != null) {
                    Tweens.removeTweens(this._reels, "all");
                    Tweens.alphaTween(this._reels, {
                        alphas: [1, 0],
                        tweenDuration: 15,
                    });
                }
                if (this._noWinContainer != null) {
                    Tweens.removeTweens(this._noWinContainer, "all");
                    Tweens.alphaTween(this._noWinContainer, {
                        alphas: [1, 0],
                        tweenDuration: 15,
                    });
                }
                if (this._winContainer != null) {
                    Tweens.removeTweens(this._winContainer, "all");
                    Tweens.alphaTween(this._winContainer, {
                        alphas: [1, 0],
                        tweenDuration: 15,
                    });
                }
                if (this._paylines != null) {
                    Tweens.removeTweens(this._paylines, "all");
                    Tweens.alphaTween(this._paylines, {
                        alphas: [1, 0],
                        tweenDuration: 15,
                    });
                }
                if (this._winAnimator != null) {
                    Tweens.removeTweens(this._winAnimator, "all");
                    Tweens.alphaTween(this._winAnimator, {
                        alphas: [1, 0],
                        tweenDuration: 15,
                    });
                }
                // if(this._logo != null) {
                //     Tweens.removeTweens(this._logo, 'all');
                //     Tweens.alphaTween(this._logo, {
                //         alphas: [1, 0],
                //         tweenDuration: 15
                //     });
                // }
            }
        } else {
            if (this._reelsBack != null) {
                this._reelsBack.visible = visible;
            }
            if (this._reels != null) {
                this._reels.visible = visible;
            }
            if (this._noWinContainer != null) {
                this._noWinContainer.visible = visible;
            }
            if (this._winContainer != null) {
                this._winContainer.visible = visible;
            }
            if (this._paylines != null) {
                this._paylines.visible = visible;
            }
            if (this._winAnimator != null) {
                this._winAnimator.visible = visible;
            }
            // if(this._logo != null) {
            //     this._logo.visible = visible;
            // }
        }
    }

    initIntro(): void {
        if (GameManager.baseResponse.currentWin > 0) {
            PlayList.loop("SND_BaseRecaploop");
        } else {
            PlayList.loop("SND_BaseLoop");
        }
        this._winAnimator.showInitWins(GameManager.baseResponse.wins, GameManager.baseResponse.currentWin);
        this.toggleElements(true);
    }

    collect(): void {
        PlayList.stop("SND_BaseRecaploop");
        PlayList.loop("SND_BaseLoop");
        if (this._paylinesSelector != null) {
            this._paylinesSelector.reset();
        }
        this._winAnimator.reset(true);

        // if(this.childs['Mystery'] != null) {
        //     if (this.childs['Mystery'].getCurrentCase()=='LOOP'){
        //         this.childs['Mystery'].goToCase('END');
        //     }
        // }
    }

    spin(): void {
        PlayList.stop("SND_BaseRecaploop");
        PlayList.loop("SND_BaseLoop");
        if (this._paylinesSelector != null) {
            this._paylinesSelector.reset();
        }

        // if(this.childs['Mystery'] != null && this.childs['Mystery'].getCurrentCase()=='LOOP') {
        //     if (this.mysteryOutroAllowed) {
        //         this.childs['Mystery'].goToCase('OUTRO');
        //     } else {
        //         this.childs['Mystery'].goToCase('END');
        //     }
        // }

        // this.mysteryOutroAllowed = true;

        this._machine.spinStart(this._winAnimator.reset(false));
    }

    stop(): void {
        this._machine.spinStop(null, true);
    }

    spinReceived(): void {
        this._machine.setStoppedSymbolsArray(GameManager.baseResponse.screen.reels);
        this._machine.spinStop(null, false, true);
    }

    onReelStopped(): void {
        if (this.childs["Smoke" + this._machine.actualReelStopped] != null) {
            this.childs["Smoke" + this._machine.actualReelStopped].goToCase("START");
        }
        if (this._machine.actualReelStopped === 2 && this.childs["Teasing"] != null) {
            if (
                this.childs["Teasing"].getCurrentCase() === "START" + this._teasingPostfix ||
                this.childs["Teasing"].getCurrentCase() === "LOOP" + this._teasingPostfix
            ) {
                this.childs["Teasing"].goToCase("END" + this._teasingPostfix);
            }
        }
        this._winAnimator.onReelStopped(GameManager.baseResponse.screen.reels, this._machine.actualReelStopped);
    }

    machineStopped(): void {
        let hasMystery: boolean = false;

        let mysteryWin: Communication.Game.IWin = GameManager.baseResponse.wins
            .filter((win: Communication.Game.IWin) => win.type.toString() == "mystery")
            .pop();
        if (mysteryWin != null) {
            hasMystery = true;

            let multiplier: string = NumberUtils.devide(mysteryWin.amount, BetManager.Bet);
            let arr: Array<string> = ["4", "6", "8", "20", "30", "500"];
            for (let j: number = 0; j < arr.length; j++) {
                if (arr[j] === multiplier) {
                    Mystery.MultiplierIndex = j;
                }
            }
        }

        if (hasMystery) {
            // if(this.childs['Mystery'] != null) {
            //     this.childs['Mystery'].goToCase('START');
            // }
            PlayList.play("SND_TeaserWin");
            if (this._teasingStarted) {
                this._teasingStarted = false;
            }
            this._mysteryDelay.start(30);
            this._controller.mystery();
        } else {
            // if(this.childs['Mystery'] != null) {
            //     this.childs['Mystery'].goToCase('NORMAL');
            // }
            this.machineStoppedDelayed();
        }
    }

    mysteryStoppedDelayed(): void {
        this.childs["TeasingSound"].goToOutro();
        PlayList.stop("SND_Teasing");
        this._wasFinished = false;
        this._controller.machineStopped();
        if (this._winAnimator.showWins(GameManager.baseResponse.wins, GameManager.baseResponse.currentWin)) {
            PlayList.stop("SND_BaseLoop");
        }
    }

    machineStoppedDelayed(): void {
        this.childs["TeasingSound"].goToOutro();
        PlayList.stop("SND_Teasing");
        if (this._teasingStarted) {
            PlayList.play("SND_BaseTeaserFail");
            this._teasingStarted = false;
        }

        this._wasFinished = false;
        this._controller.machineStopped();
        if (this._winAnimator.showWins(GameManager.baseResponse.wins, GameManager.baseResponse.currentWin)) {
            PlayList.stop("SND_BaseLoop");
        }
    }

    finishWinCalculation(): void {
        this._wasFinished = true;
        this._controller.winCalculationFinished();
    }

    finishWinAnimator(): void {
        if (!DataManager.Autoplay) {
            PlayList.stop("SND_BaseLoop");
            PlayList.loop("SND_BaseRecaploop");
        }
        this._controller.allWinsFinished();
    }

    resetWinAnimator(): void {
        this._winAnimator.reset(true);
    }

    intro(): void {
        PlayList.loop("SND_BaseLoop");
        this.toggleElements(true, true);
    }

    outro(): void {
        PlayList.stop("SND_BaseLoop");
        PlayList.stop("SND_BaseRecaploop");
        if (this._paylinesSelector != null) {
            this._paylinesSelector.reset();
        }

        let wasFinished: boolean = this._wasFinished;
        let inHighWins: boolean = this._winAnimator.reset(true);

        if (wasFinished) {
            this.outroFinished();
        } else {
            if (inHighWins) {
                this._outroDelay.start(60);
            } else {
                this._outroDelay.start(30);
            }
        }
    }

    outroFinished(): void {
        this._outroDelay.stop();
        this.toggleElements(false, true);
        this._controller.outroFinished();
    }

    selectPayline(): void {
        if (this._paylinesSelector != null) {
            this._paylinesSelector.select();
        }
    }

    private teasing(state: number): void {
        if (this.childs["Teasing"] != null && this.childs["Teasing"].getCurrentCase() === "NORMAL") {
            this._teasingStarted = true;
            this.childs["TeasingSound"].play();

            if (state == 1) {
                this._teasingPostfix = "_2";
            } else {
                this._teasingPostfix = "";
            }

            this.childs["Teasing"].goToCase("START" + this._teasingPostfix);
        }
    }

    disableBase(): void {
        this._winAnimator.resetTimer();
    }

    /**
     * Toggle all sounds used in base game (background, effects, .etc)
     * @param enable
     */
    toggleSounds(enable: boolean): void {
        if (enable) {
            PlayList.loop("SND_BaseLoop");
        } else {
            PlayList.stop("SND_BaseLoop");
            PlayList.stop("SND_BaseRecaploop");
        }
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/GameComponents/Base/BaseView.ts
 **/